import { AppSettingsListRequestBody } from "./app-settings-list-request-body";
import { RequestHeader } from "./request-header";

export class AppSettingsListRequest {
    header: RequestHeader;
    body: AppSettingsListRequestBody;
}
